import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNativeChrome } from '../../hooks/useNativeChrome';
import { useHaptics } from '../../hooks/useHaptics';
import { cn } from '../../lib/cn';
import { AuthPage } from '../../components/auth/parts';
import { OnboardingButton } from './OnboardingButton';
import { STEPS } from './steps';

export default function OnboardingScreen() {
  useNativeChrome();
  const navigate = useNavigate();
  const { impact } = useHaptics();
  const [step, setStep] = useState(0);

  const last = step === STEPS.length - 1;
  const { eyebrow, title, body, Card } = STEPS[step];

  function next() {
    impact('light');
    if (last) navigate('/signup');
    else setStep((s) => s + 1);
  }

  return (
    <AuthPage>
      {/* progress + skip */}
      <div className="flex items-center justify-between pt-3">
        <div className="flex items-center gap-[6px]">
          {STEPS.map((_, i) => (
            <span
              key={i}
              className={cn(
                'h-[6px] rounded-[3px] transition-all',
                i === step ? 'w-[22px] bg-accent' : 'w-[6px] bg-[#CFCFD6]'
              )}
            />
          ))}
        </div>
        <button
          type="button"
          onClick={() => navigate('/signup')}
          className="tap text-[14px] font-semibold text-ink3 active:opacity-60"
        >
          Skip
        </button>
      </div>

      {/* hero illustration */}
      <div className="flex flex-1 flex-col justify-center py-5">
        <div key={step} className="animate-slide-up px-[2px]">
          <Card />
        </div>
      </div>

      {/* copy + cta */}
      <div className="pb-2">
        <span className="text-[11px] font-extrabold uppercase tracking-eyebrow text-accent-ink">
          {eyebrow}
        </span>
        <h1 className="title mt-[10px] text-[30px] text-ink">{title}</h1>
        <p className="mt-[10px] text-[15px] font-medium leading-[1.45] text-ink2">{body}</p>
        <div className="mt-[22px]">
          <OnboardingButton onClick={next} variant={last ? 'green' : 'dark'}>
            {last ? 'Start playing' : 'Continue'}
          </OnboardingButton>
        </div>
      </div>
    </AuthPage>
  );
}
